import React from "react";
import { useFieldWrapper } from "../hooks";
import FormFieldMultiSelect from "./FormFieldMultiSelect";
import FormFieldSingleSelect from "./FormFieldSingleSelect";
import MultiSelect, { MultiSelectProps } from "./MultiSelect";
import SingleSelect, { SingleSelectProps } from "./SingleSelect";

export const SingleSelectComponentWrapper = (props: SingleSelectProps) => {
	const WrappedComponent = useFieldWrapper(SingleSelect, FormFieldSingleSelect);
	return <WrappedComponent {...props} />;
};

export const MultiSelectComponentWrapper = (props: MultiSelectProps) => {
	const WrappedComponent = useFieldWrapper(MultiSelect, FormFieldMultiSelect);
	return <WrappedComponent {...props} />;
};